import React from 'react';
import u from '../utilities/Utilities';
import EmptyPageLayout from '../components-app/EmptyPageLayout';
import {Footer,Step, LoadGraphic} from '../components-static/Common'
import store from 'store';
import '../styles/access-card.scss';
import QRCode from 'qrcode.react';
import Measure from 'react-measure';
import moment from 'moment';
import { Button } from '../components-static/Input';

export default class AccessCard extends React.Component{

    state={
        step:"view",
        instantiated:false,
        content:{
            floors: {},
            visitor:{
                token:"none",
            },
        },
        loading:true,
        loadText:"Verifying Token...",
        dimensions:{width:0,height:0},
        print:false,

        callLiftDetails:{
            building:'',
        },

        callLiftResult:{

        },

        buildingSetup:{},
        buildingOptions:[],
        floorPad:null,
    };

    componentDidMount=()=>{
        const token = store.get("access-card-token");
        if(token){
            this.getAppointmentDetails(token);
        }
        else{
            this.setState({step:"error",loading:false});
        }
        const action = u.getQuery(this.props,"action");
        this.setState({instantiated:true,print:(action=="print")});
    };

    getAppointmentDetails=(token)=>{
        u.post({
            url:"/noauth/get-access-card",
            data:{
                token:token
            },
            success:({valid,appointment,visitor,buildingSetup})=>{
                console.log('get-access-card callback:', {valid,appointment,visitor,buildingSetup});
                if(valid){
                    appointment.visitor=visitor;

                    const isMultiBuilding = appointment.floors ? Object.keys(appointment.floors).every((building)=>appointment.floors[building].length > 0) : false;
                    // const isMultiBuilding = false;
                    const onlyBuilding = isMultiBuilding ? null : (appointment.floors ? Object.keys(appointment.floors).find((building)=>appointment.floors[building].length > 0) : null);
                    const accessibleBuildings = isMultiBuilding ? Object.keys(appointment.floors) : [onlyBuilding];
                    const buildingOptions = Object.keys(buildingSetup || {}).map((building) => ({value: building, label: building, enabled: accessibleBuildings.indexOf(building) != -1}));
                    const defaultBuilding = isMultiBuilding ? accessibleBuildings[0] : onlyBuilding;

                    this.setState({
                        content:appointment,loading:false,
                        isMultiBuilding:isMultiBuilding,
                        buildingOptions:buildingOptions,
                        buildingSetup: buildingSetup || {},
                        callLiftDetails:{
                            building: defaultBuilding,
                            fromFloor: '2',
                            toFloor: this.getDefaultFloor(appointment, defaultBuilding),
                        }
                    });

                    if(this.state.print){
                        setTimeout(()=>{
                            window.print();
                        },500);
                    }
                }
                else{
                    this.setState({step:"error",loading:false,step:"error"});
                }
            },
            error:(error)=>{
                this.setState({error:error,loadText:error,step:"error"});
            },
        });
    };

    getDefaultFloor = (appointment, building) => {
        const floors = appointment.floors || {};
        const buildingFloors = floors[building] || [];

        const defaultFloor = building == 'East' ? appointment.defaultFloorEast
            : building == 'West' ? appointment.defaultFloorWest
            : appointment.defaultFloor;

        if(defaultFloor && buildingFloors.indexOf(defaultFloor) != -1){
            return defaultFloor + '';
        }

        return buildingFloors.length > 0 ? buildingFloors[0] + '' : '';
    }

    onChangeCallLift = (value, label) => {
        const {callLiftDetails} = this.state;

        callLiftDetails[label] = value;

        if(label == 'building'){
            callLiftDetails.fromFloor = '2';
            callLiftDetails.toFloor = this.getDefaultFloor(this.state.content, value);
        }

        this.setState({callLiftDetails:callLiftDetails});
    }

    swapFloors = () => {
        const {callLiftDetails} = this.state;
        const temp = callLiftDetails.fromFloor;
        callLiftDetails.fromFloor = callLiftDetails.toFloor;
        callLiftDetails.toFloor = temp;
        this.setState({callLiftDetails:callLiftDetails});
    }

    openFloorPad = (which) => {
        this.setState({floorPad:which});
        document.getElementById('floor-pad-dialog').showModal();
    }

    closeFloorPad = () => {
        document.getElementById('floor-pad-dialog').close();
        this.setState({floorPad:null});
    }

    onFloorPadBackdropClick = (e) => {
        if(e.target.id == 'floor-pad-dialog'){
            this.closeFloorPad();
        }
    }

    selectFloor = (floor) => {
        const {callLiftDetails, floorPad} = this.state;
        callLiftDetails[floorPad] = floor;
        this.setState({callLiftDetails:callLiftDetails, error:null});
        this.closeFloorPad();
    }

    callLift = () => {

        const {callLiftDetails} = this.state;

        u.post({
            url: '/noauth/call-lift',
            data: {
                token: this.state.content.visitor.token,
                building: callLiftDetails.building,
                fromLevel: callLiftDetails.fromFloor,
                toLevel: callLiftDetails.toFloor,
            },
            success: ({liftName, liftID}) => {
                this.setState({ step: "call-lift-success", callLiftResult: {liftName, liftID} });
                document.getElementById('call-lift-dialog').close();
            },
            error: (error) => {
                this.setState({ error: error });
                document.getElementById('call-lift-dialog').close();
            }
        })
    }

    render=()=>{
        if(!this.state.instantiated && this.state.loading){
            return <div/>
        }
        const content=this.state.content;

        const width = Math.floor(this.state.dimensions.width);
        const logoWidth = Math.round(width * 0.25);
        const singleDay = moment(content.start).isSame(content.end,"day");
        const {floors} = content || {};

        const {buildingOptions, callLiftDetails, buildingSetup} = this.state;

        const accessibleFloors = floors[callLiftDetails.building] ? ['2', ...floors[callLiftDetails.building].map((floor) => floor + '')] : [];
        const numberOfFloors = buildingSetup[callLiftDetails.building] ? buildingSetup[callLiftDetails.building].numberOfFloors : 0;
        const evenFloors = [];
        const oddFloors = [];
        for(let i = numberOfFloors; i >= 2; i--){
            const floor = {value: i + '', enabled: accessibleFloors.indexOf(i + '') != -1};
            (i % 2 === 0 ? evenFloors : oddFloors).push(floor);
        }
        const allFloors = [];
        for(let i = 0; i < Math.max(evenFloors.length, oddFloors.length); i++){
            if(evenFloors[i]) allFloors.push(evenFloors[i]);
            if(oddFloors[i]) allFloors.push(oddFloors[i]);
        }

        return (
            <EmptyPageLayout url="/access-card" title="Access Card">
                <div className="access-container">
                    <Step active={this.state.step=="view"}>
                        <div style={{position:"relative"}}>
                            <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                            <div className="access-card-container">
                                {
                                    (this.state.print)
                                        ?
                                        <img src="/images/app/soilbuild-go-logo-black.png" className="soilbuild-logo"/>
                                        :
                                        <img src="/images/app/soilbuild-go-logo.png" className="soilbuild-logo"/>
                                }

                                <Measure bounds onResize={contentRect => {this.setState({dimensions:contentRect.bounds})}}>
                                    {
                                        ({measureRef})=>
                                            (
                                                <div ref={measureRef} className="qr-code">
                                                    <QRCode value={content.visitor.token} size={width} renderAs="svg" level={(this.state.print) ? "L" : "Q"}
                                                        imageSettings={(this.state.print) ? undefined : {
                                                        src:(this.state.print) ? "/images/cards/soilbuild-qr-black.png" : "/images/cards/soilbuild-qr.png",
                                                        width:logoWidth,
                                                        height:logoWidth,
                                                    }}/>
                                                </div>
                                            )
                                    }
                                </Measure>
                                <div className='call-lift-button-wrapper no-print'>
                                    <div className='call-lift-button'>
                                        <Button type="large no-print" onClick={() => this.setState({ step: "call-lift" })}>
                                            <img src='/images/access-page/lift.png' className='button-icon'/>Call Lift
                                        </Button>
                                    </div>
                                </div>
                                <div className="access-details">
                                    <div className="details-item bold">
                                        <div className="details-left">Guest:</div>
                                        <div className="details-right">{content.visitor.visitorName}</div>
                                    </div>

                                    <div className="details-item">
                                        <div className="details-left">Unit:</div>
                                        <div className="details-right">{content.tenantBlock}, {content.tenantUnit}</div>
                                    </div>

                                    <div className="details-item">
                                        <div className="details-left"><span className="mobile-hide">Valid </span>From:</div>
                                        <div className="details-right"><span className="mobile-hide no-print">From: </span>{moment(content.start).format("DD MMM YYYY (h:mma)")}</div>
                                    </div>

                                    <div className="details-item">
                                        <div className="details-left"><span className="mobile-hide">Valid </span>To:</div>
                                        <div className="details-right"><span className="mobile-hide no-print" style={{marginRight:"17px"}}>To: </span>{moment(content.end).format("DD MMM YYYY (h:mma)")}</div>
                                    </div>

                                    <div className="access-divider">
                                        <div className="access-invite no-print"><div className="access-invite-text">Invited By</div></div>
                                        <div className="access-divider-line"/>
                                    </div>

                                    <div className="details-item" style={{marginTop:"5px"}}>
                                        <div className="details-left">Invited By:</div>
                                        <div className="details-right">{content.staffName}</div>
                                    </div>

                                    <div className="details-item">
                                        <div className="details-left">Tenant:</div>
                                        <div className="details-right">{content.tenantName}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="no-print access-disclaimers">
                                <div className="disclaimer-text"><img src='/images/access-page/info.png' className='disclaimer-icon'/>Instructions</div>
                                <div style={{textAlign:"left",display:"block",width:"100%"}}>
                                    <ul>
                                        <li>Access pass only allows for entry during the validity period & is required to exit the property</li>
                                        <li>Access pass cannot be transferred or shared. Anti-passback protocols are established so you cannot enter again without exiting first</li>
                                        <li>Visit the reception counter if you are unable to enter the building due to Anti-Passback</li>
                                        <li className="no-print">If you do not have access to a smartphone or internet connection, a printed copy can be produced at the reception counter</li>
                                        <li>Upon entering, you agree to allow Building Management to use & distribute your information during an emergency</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="print-only access-disclaimers">
                                <div className="disclaimer-text">Instructions</div>
                                <div>
                                    <div className="disclaimer-li">Access pass only allows for entry during the validity period & is required to exit the property</div>
                                    <div className="disclaimer-li">Access pass cannot be transferred or shared. Anti-passback protocols are established so you cannot enter again without exiting first</div>
                                    <div className="disclaimer-li">Visit the reception counter if you are unable to enter the building due to Anti-Passback</div>
                                    <div className="disclaimer-li">Upon entering, you agree to allow Building Management to use & distribute your information during an emergency</div>
                                </div>
                            </div>
                        </div>
                    </Step>
                    <Step active={this.state.step == "call-lift"}>
                        <div style={{display:"flex",flexDirection:"column",alignItems:"center", justifyContent:"center",position:"relative"}}>
                            <div className="access-card-container">
                                <h2>Call Lift</h2>

                                <div className='access-building-toggle'>
                                    {
                                        buildingOptions.map((option,index)=>
                                            <div
                                                key={index}
                                                className={'access-building-toggle-option' + (callLiftDetails.building == option.value ? ' selected' : '') + (option.enabled ? '' : ' disabled')}
                                                onClick={() => option.enabled && this.onChangeCallLift(option.value,'building')}
                                            >
                                                {option.label}
                                            </div>
                                        )
                                    }
                                </div>

                                <div className='floor-select-container'>
                                    <div className='floor-select-card from' onClick={() => this.openFloorPad('fromFloor')}>
                                        <div className='floor-select-label'><img src='/images/access-page/from.png' className='floor-select-icon'/>From</div>
                                        <div className='floor-select-value'>{callLiftDetails.fromFloor}</div>
                                    </div>
                                    <div className='floor-select-arrow'><img src='/images/access-page/arrow.png' className='floor-select-arrow-icon'/></div>
                                    <div className='floor-select-card to' onClick={() => this.openFloorPad('toFloor')}>
                                        <div className='floor-select-label'><img src='/images/access-page/to.png' className='floor-select-icon'/>To</div>
                                        <div className='floor-select-value'>{callLiftDetails.toFloor}</div>
                                    </div>
                                </div>

                                <div className='floor-switch-link'>
                                    <a onClick={this.swapFloors}><img src='/images/access-page/switch.png' className='floor-switch-icon'/>Switch</a>
                                </div>

                                <span className='call-lift-error'>{this.state.error}</span>
                                <div className='lift-submit-button'>
                                    <Button type="large" onClick={() => {
                                        if(callLiftDetails.fromFloor == callLiftDetails.toFloor){
                                            this.setState({error:"From and To floors cannot be the same"});
                                            return;
                                        }else{
                                            this.setState({error:null});
                                        }
                                        document.getElementById('call-lift-dialog').showModal()
                                    }}><img src='/images/access-page/lift.png' className='button-icon'/>Call Lift</Button>
                                    <Button style={{}} type="large secondary" onClick={() => {
                                        this.setState({ step: "view", error: null });
                                    }}>
                                        <img src='/images/access-page/back.png' className='button-icon'/>
                                        Back to Access Pass
                                    </Button>
                                </div>
                            </div>
                            <div className="no-print access-disclaimers">
                                <div className="disclaimer-text"><img src='/images/access-page/info.png' className='disclaimer-icon'/>Instructions</div>
                                <div style={{textAlign:"left",display:"block",width:"100%"}}>
                                    <ul>
                                        <li>Access pass only allows for entry during the validity period & is required to exit the property</li>
                                        <li>Access pass cannot be transferred or shared. Anti-passback protocols are established so you cannot enter again without exiting first</li>
                                        <li>Visit the reception counter if you are unable to enter the building due to Anti-Passback</li>
                                        <li className="no-print">If you do not have access to a smartphone or internet connection, a printed copy can be produced at the reception counter</li>
                                        <li>Upon entering, you agree to allow Building Management to use & distribute your information during an emergency</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="print-only access-disclaimers">
                                <div className="disclaimer-text">Instructions</div>
                                <div>
                                    <div className="disclaimer-li">Access pass only allows for entry during the validity period & is required to exit the property</div>
                                    <div className="disclaimer-li">Access pass cannot be transferred or shared. Anti-passback protocols are established so you cannot enter again without exiting first</div>
                                    <div className="disclaimer-li">Visit the reception counter if you are unable to enter the building due to Anti-Passback</div>
                                    <div className="disclaimer-li">Upon entering, you agree to allow Building Management to use & distribute your information during an emergency</div>
                                </div>
                            </div>
                        </div>
                    </Step>
                    <Step active={this.state.step == "call-lift-success"}>
                        <div style={{position: 'relative'}}>
                            <div className="access-card-container">
                                <h2>Lift is Coming</h2>
                                <span>Please proceed to</span>

                                <div className='lift-result'>
                                    <span className='lift-id'>{this.state.callLiftResult.liftName}</span>
                                </div>

                                <div className='lift-result'>
                                    <div className='lift-result-item'>
                                        <span className='lift-result-label'>Building:</span>
                                        <span className='lift-result-value'>{this.state.callLiftDetails.building}</span>
                                    </div>
                                    <div className='lift-result-item'>
                                        <span className='lift-result-label'>Level:</span>
                                        <span className='lift-result-value'>{this.state.callLiftDetails.fromFloor} Floor</span>
                                    </div>
                                </div>

                                <div className='lift-result'>
                                    <span className="destination-label">Destination: </span>
                                    <span className='destination-value'>{this.state.callLiftDetails.toFloor} Floor</span>
                                </div>

                                <div className='lift-submit-button'>
                                    <Button margin="20px" type="large" onClick={() => this.setState({ step: "view" })}>Back to Access Pass</Button>
                                </div>
                            </div>
                            <div className="no-print access-disclaimers">
                                <div className="disclaimer-text"><img src='/images/access-page/info.png' className='disclaimer-icon'/>Instructions</div>
                                <div style={{textAlign:"left",display:"block",width:"100%"}}>
                                    <ul>
                                        <li>Access pass only allows for entry during the validity period & is required to exit the property</li>
                                        <li>Access pass cannot be transferred or shared. Anti-passback protocols are established so you cannot enter again without exiting first</li>
                                        <li>Visit the reception counter if you are unable to enter the building due to Anti-Passback</li>
                                        <li className="no-print">If you do not have access to a smartphone or internet connection, a printed copy can be produced at the reception counter</li>
                                        <li>Upon entering, you agree to allow Building Management to use & distribute your information during an emergency</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="print-only access-disclaimers">
                                <div className="disclaimer-text">Instructions</div>
                                <div>
                                    <div className="disclaimer-li">Access pass only allows for entry during the validity period & is required to exit the property</div>
                                    <div className="disclaimer-li">Access pass cannot be transferred or shared. Anti-passback protocols are established so you cannot enter again without exiting first</div>
                                    <div className="disclaimer-li">Visit the reception counter if you are unable to enter the building due to Anti-Passback</div>
                                    <div className="disclaimer-li">Upon entering, you agree to allow Building Management to use & distribute your information during an emergency</div>
                                </div>
                            </div>
                        </div>
                    </Step>
                    <Step active={this.state.step == "error"}>
                        <div className="access-error">
                            <h1 className="text-negative" style={{marginTop:"0"}}>Invalid Access Pass</h1>
                            <div>
                                <div style={{margin:"20px auto"}}>Please ensure that you arrived at this page from the link provided in your email</div>
                                <div style={{margin:"20px auto"}}>If you are still seeing this message, your appointment may be been cancelled or your access revoked. Please proceed to the reception counter for assistance</div>
                            </div>
                        </div>
                    </Step>

                    <div className="no-print" style={{position:"relative"}}>
                        <Footer type="half"/>
                    </div>

                    <div className="print-only bottom-divider"/>

                    <dialog id='call-lift-dialog' className='call-lift-dialog'>
                        <div className='dialog-content'>
                            <h2>Call lift from Level {this.state.callLiftDetails.fromFloor} to Level {this.state.callLiftDetails.toFloor} in {this.state.callLiftDetails.building} building?</h2>
                            <div className='dialog-buttons'>
                                <Button type ="large" onClick={() => document.getElementById('call-lift-dialog').close()}>Close</Button>
                                <Button type="large" onClick={this.callLift}>Confirm</Button>
                            </div>
                        </div>
                    </dialog>

                    <dialog id='floor-pad-dialog' className='floor-pad-dialog' onClick={this.onFloorPadBackdropClick}>
                        <div className='floor-pad-content'>
                            <h2 className='floor-pad-title'>
                                {
                                    this.state.floorPad == 'fromFloor'
                                        ?
                                        <span><img src='/images/access-page/from.png' className='floor-select-icon'/>From?</span>
                                        :
                                        <span><img src='/images/access-page/to.png' className='floor-select-icon'/>Where To?</span>
                                }
                            </h2>
                            <div className='floor-pad-grid'>
                                {
                                    allFloors.map((floor,index)=>{
                                        const selected = this.state.floorPad && callLiftDetails[this.state.floorPad] == floor.value;
                                        return (
                                            <button
                                                key={index}
                                                className={'floor-pad-button' + (selected ? ' selected' : '') + (floor.enabled ? '' : ' disabled')}
                                                disabled={!floor.enabled}
                                                onClick={() => this.selectFloor(floor.value)}
                                            >
                                                {floor.value}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </dialog>
                </div>
            </EmptyPageLayout>
        )
    };
}
